import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

// Deactivate Business License And Permit
export const deactivateBLPByRecordId = async (ids) => {
  return await axios.put(
    `${api_base_url}/BusinessLicensePermits/BusLicensePermitToDeactivate`,
    ids
  );
};

export const getBusLicenseAndPermitByRecordId = async (recordId) => {
  return await axios
    .get(`${api_base_url}/BusinessLicensePermits/${recordId}`)
    .then((res) => {
      return res.data;
    });
};

// Get Vendors
export const getVendors = async () => {
  const data = await axios.get(`${api_base_url}/Common/Vendors`);
  return data;
};

export const getBusLicenseAndPermitBy = async (searchDetails) => {
  return await axios.post(
    `${api_base_url}/BusinessLicensePermits/searchDetails`,
    searchDetails
  );
};

export const getBusinessLicenseByOfficeId = async (officeId) => {
  return await axios
    .get(`${api_base_url}/BusinessLicensePermits/OfficeId/${officeId}`)
    .then((res) => {
      return res.data;
    });
};

export const getBusinessLicensePermitRenewalStatus = async () => {
  return await axios
    .get(`${api_base_url}/BusinessLicensePermits/RenewalStatus`)
    .then((res) => {
      return res.data;
    });
};

export const getBusinessLicensePermitRenewalStatusOptions = async () => {
  return await axios
    .get(`${api_base_url}/BusinessLicensePermits/RenewalStatusOptions`)
    .then((res) => {
      return res.data;
    });
};

export const getBusinessLicensePermitLicenseStatusOptions = async () => {
  return await axios
    .get(`${api_base_url}/BusinessLicensePermits/LicenseStatusOptions`)
    .then((res) => {
      return res.data;
    });
};

export const getBusLicensePermitCount = async () => {
  return axios
    .get(`${api_base_url}/BusinessLicensePermits/GetCount/`)
    .then((res) => {
      return res.data;
    });
};
